import * as React from "react";

import "./create-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {ModalService3}  from "@Common/ui-components/modal-service-3/modal-service-3";

export const CreateModal = ({entityId, next: rootNext}) => cs(
    () => ModalService3({
        // initShow: isDevQuan(),
        width: 900,
        xdQaName: "Create Mailing List Modal",
        contentService: ({params, close, next}: any) => params?.service({
            onClose: close,
            onCancel: close,
            countryCode: "US",
            onCreated: params.onCreated,
            entityId,
            next,
        }),
        rootNext,
    })
);